import React, { useEffect, useState } from 'react'
import { create } from 'axios'
import { API_URL } from '../config'
const axios = create()
const STORIES_URL = `${API_URL}storiesIVF.php`

const Backend = () => {
    const [stories, setStories] = useState([])
    const [selectedStory, setSelectedStory] = useState(null)
    const [storyLink, setStoryLink] = useState('')
    const [status, setStatus] = useState('Active')
    const [message, setMessage] = useState('')
    const [description, setDescription] = useState('');
    useEffect(() => {
        fetchStories()
    }, [])

    const fetchStories = async () => {
        try {
            const response = await axios.post(STORIES_URL, {
                action: 'list',
                status: 'Active',
            })

            const data = response.data?.data || response.data
            setStories(Array.isArray(data) ? data : [])
            setMessage('')
        } catch (error) {
            console.error('Failed to load stories:', error)
            setMessage('Unable to load active stories.')
        }
    }

    const handleRowClick = (story) => {
        setSelectedStory(story)
        setStoryLink(story.storyLink || story.storylink || story.link || '');
        setDescription(story.description || '');
        setStatus(story.status || 'Active')
        setMessage('')
    }

    const getRecordId = (story) => {
        return story?.id ?? story?.storyId ?? story?.story_id ?? story?.storyid ?? story?.sid ?? story?.id_story ?? null
    }
    const handleSubmit = async (event) => {
        event.preventDefault()

        const trimmedStoryLink = storyLink.trim()
        const youtubeWatchLinkRegex = /^https:\/\/www\.youtube\.com\/watch\?v=[A-Za-z0-9_-]{11}(?:[?&].*)?$/

        if (!trimmedStoryLink) {
            setMessage('Please provide a story link.')
            return
        }

        if (!youtubeWatchLinkRegex.test(trimmedStoryLink)) {
            setMessage('Please provide a valid YouTube watch link starting with https://www.youtube.com/watch?v=')
            return
        }

        try {
            if (selectedStory) {
                const id = getRecordId(selectedStory)
                if (!id) {
                    setMessage('Unable to update story without an identifier.')
                    return
                }

                const response = await axios.post(STORIES_URL, {
                    action: 'update',
                    id,
                    storyLink: trimmedStoryLink, 
                    description,
                    status,
                })

                setMessage(response.data?.message || 'Story updated successfully.')
            } else {
                const response = await axios.post(STORIES_URL, {
                    action: 'add',
                    storyLink: trimmedStoryLink,
                    description,
                    status,
                })

                setMessage(response.data?.message || 'Story added successfully.')
            }

            fetchStories()
            setStoryLink('')
            setDescription('')
            setStatus('Active')
            setSelectedStory(null)
        } catch (error) {
            console.error('Save failed:', error)
            setMessage('Failed to save story.')     
        }
    }

    return (
        <section className="backend-page">
            <h2 style={{ marginBottom: '1rem' }}>Stories IVF Backend</h2>
            <div className="backend-grid">
                <div className="backend-card">
                    <h3 style={{ marginBottom: '1rem' }}>Active Stories</h3>
                    <div style={{ overflowX: 'auto' }}>
                        <table className="backend-table" style={{ width: '100%' }}>
                            <thead>
                                <tr style={{ textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>
                                    <th style={{ padding: '0.75rem 0.5rem' }}>Story Link</th>
                                    <th style={{ padding: '0.75rem 0.5rem' }}>Description</th>
                                    <th style={{ padding: '0.75rem 0.5rem' }}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stories.length === 0 ? (
                                    <tr>
                                        <td colSpan="2" style={{ padding: '1rem', color: '#64748b' }}>
                                            No active stories found.
                                        </td>
                                    </tr>
                                ) : (
                                    stories.map((story, index) => (
                                        <tr
                                            key={index}
                                            onClick={() => handleRowClick(story)}
                                            style={{
                                                cursor: 'pointer',
                                                background: selectedStory === story ? '#eef2ff' : 'transparent',
                                                borderBottom: '1px solid #e2e8f0',
                                            }}
                                        >
                                            <td data-label="Story Link" style={{ padding: '0.75rem 0.5rem', wordBreak: 'break-all', color: '#0664fa', transition: 'background 0.3s', }}>
                                                {story.storyLink || story.storylink || story.link || '-'}
                                            </td>
                                            <td data-label="description" style={{ padding: '0.75rem 0.5rem', wordBreak: 'break-all', color: '#161616', transition: 'background 0.3s', }}>
                                                {story.description || '-'}
                                            </td>
                                            <td data-label="Status" style={{ padding: '0.75rem 0.5rem' }}>
                                                {story.status || 'Active'}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="backend-card">
                    <h3 style={{ marginBottom: '1rem' }}>Add/Edit Selected Story</h3>
                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Story Link</label>
                            <input
                                type="text"
                                name="storyLink"
                                value={storyLink}
                                onChange={(e) => setStoryLink(e.target.value)}
                                placeholder="Youtube link (e.g., https://www.youtube.com/watch?v=VIDEO_ID)"
                                style={{ width: '96%', padding: '0.35rem', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.96rem' }}
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Description</label>
                            <input
                                type="text"
                                name="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Story description Max 30 Characters"
                                style={{ width: '96%', padding: '0.35rem', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.96rem' }}
                            />
                        </div>
                        <div style={{ marginBottom: '1rem' }}>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Status</label>
                            <select
                                name="status"
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                                style={{ width: '98%', padding: '0.35rem', borderRadius: '12px', border: '1px solid #cbd5e1', fontSize: '0.96rem' }}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '0.95rem',
                                borderRadius: '12px',
                                border: 'none',
                                background: '#2563eb',
                                color: '#ffffff',
                                fontWeight: 700,
                                cursor: 'pointer',
                            }}
                        >
                            {selectedStory ? 'Update Story' : 'Add Story'}
                        </button>
                    </form>
                    {message && (
                        <p style={{ marginTop: '1rem', color: message.toLowerCase().includes('failed') ? '#dc2626' : '#16a34a' }}>
                            {message}
                        </p>
                    )}
                    {!selectedStory && (
                        <p style={{ marginTop: '1rem', color: '#475569' }}>
                            Click a row on the left to begin editing. or add a new story by filling the form and clicking "Add Story".
                        </p>
                    )}
                </div>
            </div>
        </section>
    )
}

export default Backend